import React from "react";
import styled from "styled-components";
import { Tag, Tooltip } from "antd";
import { PhoneOutlined, ClockCircleOutlined } from "@ant-design/icons";

const NotificationContainer = styled.div`
  margin-top: 0.5rem;
  padding: 0.5rem;
  background: #f0f9ff;
  border: 1px solid #bae6fd;
  border-radius: 0.375rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

const NotificationIcon = styled.div`
  color: #0284c7;
  font-size: 1rem;
`;

const NotificationContent = styled.div`
  flex: 1;
  font-size: 0.875rem;
`;

const NotificationTitle = styled.div`
  font-weight: 600;
  color: #0c4a6e;
  margin-bottom: 0.25rem;
`;

const NotificationDetails = styled.div`
  color: #0369a1;
  font-size: 0.75rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

const TimeStamp = styled.span`
  color: #64748b;
  font-size: 0.75rem;
`;

const StatusTag = styled(Tag)`
  margin: 0;
  font-size: 0.75rem;
  padding: 0.125rem 0.375rem;
  border-radius: 0.25rem;
`;

const CallRequestNotification = ({ callRequest, quoteId }) => {
  if (!callRequest) return null;

  const formatTime = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 1) return "Just now";
    if (diffMins < 60) return `${diffMins}m ago`;
    if (diffHours < 24) return `${diffHours}h ago`;
    if (diffDays < 7) return `${diffDays}d ago`;

    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "requested":
        return "processing";
      case "assigned":
        return "warning";
      case "completed":
        return "success";
      case "cancelled":
        return "error";
      default:
        return "default";
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case "requested":
        return "Pending";
      case "assigned":
        return "Assigned";
      case "completed":
        return "Completed";
      case "cancelled":
        return "Cancelled";
      default:
        return status;
    }
  };

  return (
    <NotificationContainer>
      <NotificationIcon>
        <PhoneOutlined />
      </NotificationIcon>

      <NotificationContent>
        <NotificationTitle>
          Call Request #{callRequest.id?.slice(-6) || "N/A"}
        </NotificationTitle>

        <NotificationDetails>
          <StatusTag color={getStatusColor(callRequest.status)}>
            {getStatusText(callRequest.status)}
          </StatusTag>

          {callRequest.phone && <span>📞 {callRequest.phone}</span>}

          {callRequest.preferredTime && (
            <span>
              <ClockCircleOutlined /> {callRequest.preferredTime}
            </span>
          )}
        </NotificationDetails>
      </NotificationContent>

      <Tooltip title={new Date(callRequest.requestedAt).toLocaleString()}>
        <TimeStamp>{formatTime(callRequest.requestedAt)}</TimeStamp>
      </Tooltip>
    </NotificationContainer>
  );
};

export default CallRequestNotification;
